import React from "react"
import { ConsentManager, openConsentManager } from '@segment/consent-manager'
import inEU from '@segment/in-eu'
import { ConsentManagerProps } from "@segment/consent-manager/types/types";

export interface ISegmentConsentManager {
    segmentWriteKey: string;
    className?: string;
    bannerContent?: React.ReactNode;
    bannerSubContent?: string;
    preferencesDialogTitle?: string;
    preferencesDialogContent?: string;
    cancelDialogTitle?: string;
    cancelDialogContent?: string;
    bannerBgColor?: string;
    consentManagerProps?: Partial<ConsentManagerProps>
}

export const SegmentConsentManager: React.FC<ISegmentConsentManager> = ({
    segmentWriteKey,
    className,
    bannerContent,
    bannerSubContent,
    preferencesDialogTitle,
    preferencesDialogContent,
    cancelDialogTitle,
    cancelDialogContent,
    bannerBgColor = "var(--color-body-bg-inverted)",
    consentManagerProps,
}) => {

    !bannerContent && (bannerContent = (
        <span>
            We use cookies (and other similar technologies) to collect data to improve your experience on
            our site. By using our website, you’re agreeing to the collection of data.
        </span>
    ))
    !bannerSubContent && (bannerSubContent = 'You can change your preferences at any time.')
    !preferencesDialogTitle && (preferencesDialogTitle = 'Website Data Collection Preferences')
    !preferencesDialogContent && (preferencesDialogContent =
        'We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, deliver personalized advertisements, and increase the overall performance of our site.')
    !cancelDialogTitle && (cancelDialogTitle = 'Are you sure you want to cancel?')
    !cancelDialogContent && (cancelDialogContent =
        'Your preferences have not been saved. By continuing to use our website, you՚re agreeing to our Website Data Collection Policy.')

    return (
        <div className={`fixed bottom-0 left-0 right-0 z-50 ${className}`}>
            <ConsentManager
                writeKey={segmentWriteKey}
                bannerBackgroundColor={bannerBgColor}
                shouldRequireConsent={() => { return true }}
                bannerContent={bannerContent}
                bannerSubContent={bannerSubContent}
                preferencesDialogTitle={preferencesDialogTitle}
                preferencesDialogContent={preferencesDialogContent}
                cancelDialogTitle={cancelDialogTitle}
                cancelDialogContent={cancelDialogContent}
                closeBehavior={"accept"}
                {...consentManagerProps}
            />
        </div>
    )
}

export default SegmentConsentManager